import React, { useEffect, useState } from 'react';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
const checkoutBasico = 'https://argentina.recursodigital.shop/cart/48789960720603:1';
const checkoutCompleto = 'https://argentina.recursodigital.shop/cart/48789962490075:1';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 46,
    seconds: 34
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (v: number) => v.toString().padStart(2, '0');
  return <section className="bg-premium-gradient text-white pt-10 pb-8 px-5 relative overflow-hidden" data-id="element-112">
      <div className="absolute inset-0 bg-radial-glow opacity-60 pointer-events-none" data-id="element-113" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-114">
        <h2 className="text-2xl md:text-4xl font-black mb-12 leading-tight text-center" data-id="element-115">
          Podés seguir esperando…{' '}
          <span className="text-blue-400" data-id="element-116">
            o empezar a preparar tu hogar hoy.
          </span>
        </h2>

        <div className="text-center mb-10" data-id="element-117">
          <p className="text-sm text-gray-400 mb-4 font-medium" data-id="element-118">
            🚨 El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-end justify-center gap-1 mb-2" data-id="element-119">
            <div className="text-center" data-id="element-120">
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-121">
                {fmt(timeLeft.hours)}
              </span>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1" data-id="element-122">
                HS
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-blue-400 pb-1" data-id="element-123">
              :
            </span>
            <div className="text-center" data-id="element-124">
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-125">
                {fmt(timeLeft.minutes)}
              </span>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1" data-id="element-126">
                MIN
              </p>
            </div>
            <span className="text-4xl md:text-5xl font-black text-blue-400 pb-1" data-id="element-127">
              :
            </span>
            <div className="text-center" data-id="element-128">
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-129">
                {fmt(timeLeft.seconds)}
              </span>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1" data-id="element-130">
                SEG
              </p>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-3" data-id="element-131">
            Después sube a{' '}
            <span className="text-red-400 font-bold" data-id="element-132">$49.990 ARS</span> y no
            vuelve.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6" data-id="element-133">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-5 text-center flex flex-col transition-all hover:bg-white/10" data-id="element-134">
            <div className="text-3xl mb-2" data-id="element-135">📘</div>
            <h4 className="text-sm font-black text-white uppercase mb-1" data-id="element-136">
              MEGAPACK HOGAR PREPARADO™
            </h4>
            <p className="text-[11px] text-gray-500 mb-4" data-id="element-137">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-138">
              <div className="text-xs text-gray-600 line-through mb-0.5" data-id="element-139">
                $27.990 ARS
              </div>
              <div className="text-2xl font-black text-white mb-4" data-id="element-140">
                $19.990 ARS
              </div>
              <a href={checkoutBasico} className="block w-full border-2 border-blue-500 text-blue-400 font-black text-sm py-4 px-4 rounded-xl hover:bg-blue-500/10 transition-colors text-center" data-id="element-141">
                QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-white/5 backdrop-blur-md border-2 border-blue-500 rounded-2xl p-6 text-center flex flex-col transition-all hover:scale-[1.02]" data-id="element-142">
            <div className="text-3xl mb-2" data-id="element-143">🏆</div>
            <h4 className="text-sm font-black text-white uppercase mb-1" data-id="element-144">
              MEGAPACK + SISTEMA ⭐
            </h4>
            <p className="text-[11px] text-gray-400 mb-4" data-id="element-145">
              6 Tomos + 6 Bonos + Sistema
            </p>
            <div className="mt-auto" data-id="element-146">
              <div className="text-xs text-gray-600 line-through mb-0.5" data-id="element-147">
                $49.990 ARS
              </div>
              <div className="text-2xl font-black text-white mb-4" data-id="element-148">
                $27.990 ARS
              </div>
              <a href={checkoutCompleto} className="block w-full btn-premium font-black text-sm py-4 px-4 rounded-xl transition-all text-center" data-id="element-149">
                QUIERO TODO EL SISTEMA
              </a>
            </div>
          </div>
        </div>

        <div className="text-center space-y-2 mt-8" data-id="element-150">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-gray-400" data-id="element-151">
            <div className="flex items-center gap-1.5" data-id="element-152">
              <Lock size={13} className="text-blue-400" data-id="element-153" />
              Pago 100% seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-154">
              <Zap size={13} className="text-blue-400" data-id="element-155" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-1.5" data-id="element-156">
              <ShieldCheck size={13} className="text-blue-400" data-id="element-157" />
              Garantía total
            </div>
          </div>
          <div className="flex items-center justify-center gap-1.5 text-gray-500 text-[14px] font-[600]" data-id="element-158">
            Pagá con tarjeta o MercadoPago de forma segura y accedé al material
            HOY
          </div>
        </div>
      </div>
    </section>;
}